const createHistory = require('history').createBrowserHistory

const history = new createHistory()

export default history
